<template>
  <div class="relative langdrop">
    <button
      @click="toggleDropdown"
      class="flex items-center justify-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-900 hover:text-[#ffb47c] transition-colors duration-150 glass-effect"
    >
      <GlobeIcon class="h-5 w-5 mr-2" />
      <span>{{ currentLanguage.toUpperCase() }}</span>
      <ChevronDownIcon class="h-4 w-4 ml-1" />
    </button>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute right-0 mt-2 w-32 origin-top-right rounded-md shadow-lg py-1 glass-effect ring-1 ring-black ring-opacity-5 focus:outline-none z-20"
      >
        <a
          v-for="lang in availableLanguages"
          :key="lang.code"
          href="#"
          @click.prevent="switchLanguage(lang.code)"
          :class="[
            'block px-4 py-2 text-sm',
            currentLanguage === lang.code
              ? 'font-semibold text-brand-secondary'
              : 'text-gray-700 hover:bg-gray-700 hover:text-white',
          ]"
        >
          {{ lang.name }}
        </a>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ChevronDownIcon, GlobeIcon } from 'lucide-vue-next'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale, t } = useI18n()
const isOpen = ref(false)

const availableLanguages = [
  { code: 'en', name: 'English' },
  { code: 'tr', name: 'Türkçe' },
]

const currentLanguage = computed(() => locale.value)

function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function switchLanguage(langCode: string) {
  locale.value = langCode
  localStorage.setItem('lang', langCode)
  document.documentElement.lang = langCode // Update HTML lang attribute
  document.title = `${t((router.currentRoute.value.meta.titleKey as string) || 'nav.home')} - toruk MAGIC` // Update title
  isOpen.value = false
}

// Close dropdown if clicked outside
import router from '@/router' // Assuming router is exported from here
import { onMounted, onUnmounted } from 'vue'

const closeOnOutsideClick = (event: MouseEvent) => {
  if (isOpen.value && !(event.target as HTMLElement).closest('.langdrop')) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeOnOutsideClick)
})

onUnmounted(() => {
  document.removeEventListener('click', closeOnOutsideClick)
})
</script>
